export default __webpack_public_path__ + "static/media/ic_ahu_off.31c5701a.svg";